"use strict";

exports.__esModule = true;
exports["default"] = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/~/dom-helpers/ownerDocument.js
// module id = 690
// module chunks = 0